import React, { useContext, useState } from 'react'
import Logo from '../../assets/Logo.svg'
import { useNavigate } from 'react-router-dom'
import { DContext } from '../../context/DataContext'
import { useTranslation } from 'react-i18next'
import { FiMenu, FiShoppingBag, FiUser } from 'react-icons/fi'
import { MdCurrencyExchange, MdGTranslate } from 'react-icons/md'

function Header(props) {

  const { t } = useTranslation()

  const { cart, isAuth, setCurrency, currency } = useContext(DContext)

  const navPage = useNavigate()
  const [renderLnDropdown, setRenderLnDropdown] = useState(false)
  const [renderCrDropdown, setRenderCrDropdown] = useState(false)

  const renderCurrency = () => {
    if (currency === "usd") {
      return props.ln === "ts" ? "ดอลลาร์" : "Dollar"
    }
    else if (currency === "thb") {
      return props.ln === "ts" ? "เงินบาท" : (props.ln === "fr" ? "Baht thaïlandais" : "Thai Baht")
    }
  }

  const handleAccount = () => {
    if (isAuth) {
      window.location.href = "/account"
    }
    else {
      window.location.href = "/login"
    }
  }


  return (
    <header className='sticky top-0 left-0 z-[1010] flex items-center justify-between bg-slate-50 px-3 py-2 shadow'>
      <img className='w-[40%] min-[687px]:w-[180px]' src={Logo} alt='Be Alright Krabi Logo' role='button' onClick={() => navPage('/')} />
      <nav className='flex items-center justify-center gap-2'>
        <button className='relative hidden min-[687px]:inline-flex items-center gap-1.5 rounded-full border border-slate-800 px-3 py-1.5 text-sm font-medium text-slate-900 transition hover:bg-slate-100' onClick={() => navPage('/bucket-list')}>
          <FiShoppingBag className='text-base' />
          {t("sliderMenu.bucketList")}
          <span className='absolute left-full top-0 -translate-y-1/2 -translate-x-1/2 rounded-full bg-rose-600 px-2 text-xs font-bold text-white'>{cart.length}</span>
        </button>

        <div className='relative'>
          <button className='inline-flex items-center gap-1.5 rounded-full border border-slate-800 px-3 py-1.5 text-sm font-medium text-slate-900 transition hover:bg-slate-100' onClick={() => setRenderLnDropdown(!renderLnDropdown)}>
            <MdGTranslate className='text-base' />
            {props.ln === 'en' && 'English'}
            {props.ln === 'fr' && 'Français'}
            {props.ln === 'ts' && 'แบบไทย'}
          </button>
          {renderLnDropdown && (
            <ul className='absolute right-0 z-[1001] mt-2 min-w-[150px] overflow-hidden rounded-lg border border-slate-200 bg-white py-1 text-base shadow-lg'>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('en'); setRenderLnDropdown(false) }}>English</li>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('fr'); setRenderLnDropdown(false) }}>Français</li>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { props.changeLanguage('ts'); setRenderLnDropdown(false) }}>แบบไทย</li>
            </ul>
          )}
        </div>

        <div className='relative hidden min-[687px]:block'>
          <button className='inline-flex items-center gap-1.5 rounded-full border border-slate-800 px-3 py-1.5 text-sm font-medium text-slate-900 transition hover:bg-slate-100' onClick={() => setRenderCrDropdown(!renderCrDropdown)}>
            <MdCurrencyExchange className='text-base' />
            {renderCurrency()}
          </button>
          {
            renderCrDropdown &&
            <ul className='absolute right-0 z-[1001] mt-2 min-w-[170px] overflow-hidden rounded-lg border border-slate-200 bg-white py-1 text-base shadow-lg'>
              <li className='cursor-pointer px-3 py-2 hover:bg-slate-100' role='button' onClick={() => { setCurrency('thb'); setRenderCrDropdown(false) }}>{'฿'} {props.ln === "ts" && "เงินบาท"} {props.ln === "en" && "Thai Baht"} {props.ln === "fr" && "Baht thaïlandais"}</li>
            </ul>
          }
        </div>

        <button className='hidden min-[687px]:inline-flex rounded-full border border-slate-800 p-1.5 text-xl text-slate-900 transition hover:bg-slate-100' onClick={handleAccount} aria-label={t('sliderMenu.account')}>
          <FiUser />
        </button>
        <button className='inline-flex rounded-full border border-slate-800 p-1.5 text-xl text-slate-900 transition hover:bg-slate-100' type='button' onClick={() => props.setIsMobileMenuOpen(true)} aria-label={t('sliderMenu.openMenu')}>
          <FiMenu />
        </button>
      </nav>
    </header>
  )
}

export default Header
